import { useEffect } from 'react';

// eslint-disable-next-line no-restricted-imports -- fe-import-rule-disable: allow - shared feature-flag package is the sanctioned LaunchDarkly SDK boundary.
import { useLDClient } from 'launchdarkly-react-client-sdk';
import type { LDContext } from 'launchdarkly-react-client-sdk';

/**
 * Identifies the current feature-flag evaluation context with LaunchDarkly.
 *
 * Apps build a `context` (employee- or org-shaped) and pass it in; this hook
 * owns the vendor `useLDClient().identify()` wiring so the LD SDK stays inside
 * the feature-flag package.
 *
 * @param context - the LD context to identify, or `undefined` while initializing.
 */
export const useIdentifyFeatureFlagUser = (context: LDContext | undefined): void => {
  const ldClient = useLDClient();

  // eslint-disable-next-line modernloop/no-use-effect.cjs -- Effect synchronizes an external SDK after render.
  useEffect(() => {
    if (!ldClient || !context) {
      return;
    }
    ldClient.identify(context);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ldClient, JSON.stringify(context)]);
};
